const DEV_API = 'http://localhost:5001';
const PROD_API =
  process.env.REACT_APP_API_BASE_URL ||
  'https://diagnostic-api-0erh.onrender.com';

export const apiUrl = (path) => {
  const base = process.env.NODE_ENV === 'development' ? DEV_API : PROD_API;
  const clean = path.startsWith('/api') ? path : `/api${path}`;
  return `${base}${clean}`;
};
